export function cleanArtistTitle(track: { artist: string; title: string }) {
  const artist = track.artist.split('feat.')[0].trim();
  const title = track.title.replace(/\s*\([^)]*\)\s*/g, '').trim();
  return {
    artist,
    title,
  };
}
